import React, {Component} from 'react';

import './styles.scss';

class Footer extends Component {
  renderContainerButtonBack = () => {
    const {
      backHandle,
      styleBackgroundColorBack,
      styleColorTextBack,
      textBack,
      hideBtnBack,
    } = this.props;

    if (hideBtnBack) return <div className="button-container-empty back"></div>;
    else
      return (
        <div
          className="button-container back"
          style={{
            backgroundColor: styleBackgroundColorBack
              ? styleBackgroundColorBack
              : null,
          }}
        >
          <button
            className="back-button"
            onClick={backHandle}
            style={{color: styleColorTextBack ? styleColorTextBack : null}}
          >
            {textBack ? textBack : 'Voltar'}
          </button>
        </div>
      );
  };

  renderContainerButtonNext = () => {
    const {nextForm, nextHandle, textNext, hideBtnNext} = this.props;

    if (hideBtnNext) return <div className="button-container-empty back"></div>;
    else
      return (
        <div className="button-container next">
          <button
            id="nextButton"
            type="submit"
            className="next-button"
            onClick={nextHandle}
            form={nextForm ? nextForm : null}
            formNoValidate
          >
            {textNext ? textNext : 'Próximo'}
          </button>
        </div>
      );
  };

  render = () => {
    return (
      <div className="component-footer">
        <div className="footer">
          {this.renderContainerButtonBack()}
          <div className="separator">&nbsp;</div>
          {this.renderContainerButtonNext()}
        </div>
      </div>
    );
  };
}

export default Footer;
